<main>
    <section class="flex justify-between items-center mb-3">
        <h1 class="text-2xl font-bold text-gray-800">Tickets</h1>

        <a routerLink="/tickets/new">
            <add-button label="Nuevo"></add-button>
        </a>
    </section>

    <sau-table #sauTable [url]="url" [filterConfig]="filterConfig" contentList="list" contentTotal="count"
        pageParamName="page" limitParamName="limit" contentTotal="total" [orientation]="orientation"
        [showOptions]="showOptions" [sizeInitialPage]="1" [headers]="headers" [canEdit]="showEditAndDeleteButtons"
        (deleteEvent)="openDeleteForm($event)" [canDelete]="showEditAndDeleteButtons"
        (editEvent)="toggleEditForm($event)" [canPrint]="showPrintButton" (printEvent)="print($event)"
        (showEvent)="showDetails($event)" [customTemplates]="{ 'total': totalTmpl }">

        <ng-template #totalTmpl let-item="item">
            <div class="flex flex-col items-start gap-0.5 leading-tight">
                <span class="font-bold text-sm text-gray-900" [centToEurDisplay]="item.total"></span>
                <span class="text-xs text-gray-400"><span [centToEurDisplay]="item.subtotal"></span> sin IVA</span>
            </div>
        </ng-template>

    </sau-table>

</main>
